import { gql } from '@apollo/client';

export interface IsadDetail {
  cadastralArea: string | null;
  municipality: string | null;
  type: string | null;
  era: string | null;
  impulse: string | null;
  description: string | null;
}

export const GET_ISAD_DETAIL_QUERY = gql`
  query GetIsadDetail($id: Int!) {
    getIsadDetail(id: $id) {
      cadastralArea
      municipality
      type
      era
      impulse
      description
    }
  }
`;
